import toastr from 'toastr';
import $ from 'jquery';
import 'toastr/build/toastr.min.css';

function cleanStringToAlphanumeric(input) {
    return input.replace(/[^a-zA-Z0-9]/g, '');
}

class ToastrService {
    static instance = null;

    constructor() {
        this.activeToastIds = {}; // Store custom toast IDs

        // Set toastr options using the imported toastr
        toastr.options = {
            positionClass: 'toast-bottom-right',
            hideDuration: 300,
            timeOut: 60000
        };
    }

    static getInstance() {
        if (!ToastrService.instance) {
            ToastrService.instance = new ToastrService();
        }
        return ToastrService.instance;
    }

    InfoWithId = (data, id, options = {}) => {
        // Clear any existing toast with this ID
        id = cleanStringToAlphanumeric(id);
        this.ClearToast(id);

        // Generate a unique DOM ID for the toast
        const domId = id;
        this.activeToastIds[id] = domId;

        // Create the toast with a custom DOM ID
        toastr.info(`<div><span class="toast-message">${data}</span></div>`, undefined, {
            timeOut: 0,
            extendedTimeOut: 0
        });

        // Find the most recently created toast and add our ID
        setTimeout(() => {
            $('.toast:last').attr('id', domId);
        }, 50);

        return id;
    };

    // Create a toast with a thread navigation link
    InfoWithThreadLink = (data, id, threadId, baseUrl = '/threads/', content = '') => {
        id = cleanStringToAlphanumeric(id);

        // Generate the URL for the thread
        const threadUrl = `${baseUrl}${threadId}`;

        let toastContent = '';
        if (content) {
            if (content.length > 30) {
                toastContent = `<span class="toast-content">${content.substring(0, 30)}...</span>`;
            } else {
                toastContent = `<span class="toast-content">${content}</span>`;
            }
        }

        // Create a clickable toast with link styling and custom close button
        toastr.info(
            `<div class="toast-clickable" style="cursor: pointer; position: relative; padding-right: 30px;" onclick="window.location.href='${threadUrl}'">
        <span class="toast-message">${data}</span>
        ${toastContent}
        <button class="toast-custom-close" style="
          position: absolute;
          top: 5px;
          right: 8px;
          background: none;
          border: none;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          line-height: 1;
          padding: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.7;
          transition: opacity 0.2s;
        " onmouseover="this.style.opacity='1'" onmouseout="this.style.opacity='0.7'">×</button>
      </div>`,
            undefined, { timeOut: 0, extendedTimeOut: 0 }
        );

        // Find the most recently created toast and add our ID
        setTimeout(() => {
            const $toast = $('.toast:last');
            if ($toast.length) {
                $toast.attr('id', id);
                this.activeToastIds[id] = id;

                // Prevent navigation when clicking the close button
                $toast.find('.toast-close-button').on('click', (e) => {
                    e.stopPropagation();
                });

                // Handle custom close button
                $toast.find('.toast-custom-close').on('click', (e) => {
                    e.stopPropagation();
                    this.ClearToast(id);
                });
            }
        }, 50);

        return id;
    };

    // Update toast content using jQuery
    UpdateToast = (id, newContent) => {
        id = cleanStringToAlphanumeric(id);
        const domId = this.activeToastIds[id];
        if (!domId) {
            return false;
        }

        // Find the toast by ID and update its message content
        const $toast = $(`#${domId}`);
        if ($toast.length) {
            $toast.find('.toast-message').html(newContent);
            return true;
        }

        // If toast not found, cleanup tracking
        delete this.activeToastIds[id];
        return false;
    };

    ClearToast = (id) => {
        id = cleanStringToAlphanumeric(id);
        const domId = this.activeToastIds[id];
        if (!domId) {
            return false;
        }

        $(`#${domId}`).remove();
        delete this.activeToastIds[id];
        return true;
    };

    Info = (data) => {
        toastr.info(data);
    };

    InfoLink = (message, link) => {
        toastr.info(`<div><span>${message}</span><br/><a href="${link}" target="_blank">Link to image</a></div>`);
    }

    Success = (data) => {
        toastr.success(data);
    };

    Warning = (data) => {
        toastr.warning(data);
    };

    Error = (data) => {
        toastr.error(data);
    };

    ErrorPerminent = (data) => {
        toastr.error(data, undefined, { timeOut: 0, extendedTimeOut: 0 });
    };
}

export default ToastrService.getInstance();